<table class="__table">
  <thead>
    <tr class="__header-row">
      <th class="__header-cell" *ngFor="let columnHeader of columnHeaders">
        {{columnHeader}}
      </th>
    </tr>
  </thead>

  <!-- tbody is automatically inserted-->
  <ng-content></ng-content>
</table>
